import { ApizUIDataField, ApizUIEditTab, ApizUIField, ApizUIItemGroup } from './apiz-domains';

export function isApizUIEditTab(value: unknown): value is ApizUIEditTab {
  return (
    typeof value === 'object' &&
    'children' in value &&
    'key' in value &&
    'component' in value &&
    typeof value.component === 'string' &&
    ['GridViewUiComponent', 'EditTabUiComponent'].includes(value?.component)
  );
}

export function isApizUIItemGroup(value: unknown): value is ApizUIItemGroup<any> {
  return typeof value === 'object' && 'children' in value;
}

export function isApizUIField(value: unknown): value is ApizUIField {
  return (
    typeof value === 'object' &&
    'columnId' in value &&
    'cssClass' in value &&
    'data' in value &&
    'displayLength' in value &&
    'fieldGroup' in value &&
    'fieldId' in value &&
    'formDetailId' in value &&
    'formDetailItemId' in value &&
    'formId' in value &&
    'isCallout' in value &&
    'isRange' in value &&
    'processId' in value &&
    'referenceId' in value &&
    'tableId' in value
  );
}

export function isApizUIDataField(value: unknown): value is ApizUIDataField {
  return typeof value === 'object' && 'hasValidation' in value;
}
